import { render } from "./FeePricingManageView.vue?vue&type=template&id=76631a2e&scoped=true"
import script from "./FeePricingManageView.vue?vue&type=script&lang=js"
export * from "./FeePricingManageView.vue?vue&type=script&lang=js"

import "./FeePricingManageView.vue?vue&type=style&index=0&id=76631a2e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76631a2e"]])

export default __exports__